import axios from 'axios'
import {
  CV_REQUEST, CV_SUCCESS, CV_FAIL,
  COMPETENCES_REQUEST, COMPETENCES_SUCCESS, COMPETENCES_FAIL,
  PUBLICATIONS_REQUEST, PUBLICATIONS_SUCCESS, PUBLICATIONS_FAIL,
  HONORS_REQUEST, HONORS_SUCCESS, HONORS_FAIL,
  CONTACT_REQUEST, CONTACT_SUCCESS, CONTACT_FAIL,
} from '../constants/portfolioConstants'

export const getCV = () => async (dispatch) => {
  try {
    dispatch({ type: CV_REQUEST })
    const { data } = await axios.get('/api/portfolio/cv/')
    dispatch({ type: CV_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: CV_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const getCompetences = () => async (dispatch) => {
  try {
    dispatch({ type: COMPETENCES_REQUEST })
    const { data } = await axios.get('/api/portfolio/competences/')
    dispatch({ type: COMPETENCES_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: COMPETENCES_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const getPublications = () => async (dispatch) => {
  try {
    dispatch({ type: PUBLICATIONS_REQUEST })
    const { data } = await axios.get('/api/portfolio/publications/')
    dispatch({ type: PUBLICATIONS_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: PUBLICATIONS_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const getHonors = () => async (dispatch) => {
  try {
    dispatch({ type: HONORS_REQUEST })
    const { data } = await axios.get('/api/portfolio/honors/')
    dispatch({ type: HONORS_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: HONORS_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}

export const getContact = () => async (dispatch) => {
  try {
    dispatch({ type: CONTACT_REQUEST })
    const { data } = await axios.get('/api/portfolio/contact/')
    dispatch({ type: CONTACT_SUCCESS, payload: data })
  } catch (e) {
    dispatch({ type: CONTACT_FAIL, payload: e.response?.data?.detail ?? e.message })
  }
}
